import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo, useCallback, } from 'react';
import classnames from 'classnames';
import styles from '../../Tabs.css';
export const TabsHeader = memo(function TabsHeader(props) {
    const { children, className } = props;
    const renderLabels = useCallback((tab, index) => (_jsx("li", { children: tab }, index)), []);
    return (_jsx("ul", Object.assign({ className: classnames(className, styles.tabsLabels) }, { children: React.Children.map(children, renderLabels) }), void 0));
});
